import { z } from 'zod'
import * as http from '@/util/http'

export const DEFAULT_OPTION = -1

export const EduInfoSchema = z.object({
  region: z.string().min(1, '地方を選択してください').default(''),
  prefecture: z.string().min(1, '都道府県を選択してください').default(''),
  schoolId: z.int({ error: '学校を選択してください' }).gt(0).default(DEFAULT_OPTION),
  academicProgramId: z.int().gte(0).optional().default(DEFAULT_OPTION),
  academicCourseId: z.int().gte(0).optional().default(DEFAULT_OPTION),
  grade: z.int().gt(0).default(0),
})

export type EduInfoForm = z.input<typeof EduInfoSchema>

export const DEFAULT_EDU_INFO: EduInfoForm = EduInfoSchema.parse({})

export const CourseSchema = z.object({
  id: z.number(),
  name: z.string(),
  isActive: z.boolean(),
})

export const ProgramSchema = z.object({
  id: z.number(),
  name: z.string(),
  programType: z.string(),
  durationYears: z.number(),
  isActive: z.boolean(),
  courses: z.array(CourseSchema).optional().nullable(),
})

export const SchoolSchema = z.object({
  id: z.number(),
  name: z.string(),
  institutionType: z.string(), // z.nativeEnum(Institutiontype)
  adminDivision: z.string(), // z.nativeEnum(Prefecture)
  subnationalUnit: z.string(), // z.nativeEnum(Region)
  programs: z.array(ProgramSchema).optional().nullable(),
})

export const EducationHistorySchema = z.object({
  id: z.number().int(),
  // profileId: z.number().int(),
  programType: z.string(),
  school: SchoolSchema.optional().nullable(),
  academicProgram: ProgramSchema.optional().nullable(),
  academicCourse: CourseSchema.optional().nullable(),
  enrollmentStartDate: z.preprocess((val) => {
    if (typeof val === 'string' || val instanceof Date) return new Date(val)
  }, z.date()),
  enrollmentEndDate: z.string().optional().nullable(),
  extraInfo: z.any().optional().nullable(),
})

export type EducationHistory = z.infer<typeof EducationHistorySchema>

export async function fetchFirstEducationHistory(): Promise<EducationHistory> {
  const { data: edus } = await http.get<EducationHistory[]>(
    '/api/v1/user/profile/education-history'
  )
  return EducationHistorySchema.parse(edus.length ? edus[0] : {})
}
